import { AnchorLink } from 'gatsby-plugin-anchor-links'
import React, { FunctionComponent } from 'react'
import { Col, Row } from 'reactstrap'

import { mapToComponent } from '../../utils/helpers'

export interface MenuItem {
  name: string
  path: string
}

export const FlipCard: FunctionComponent<MenuItem> = ({ name, path }) => (
  <Col>
    <div className="flip-card m-1 fade-in">
      <div className="flip-card-inner">
        <div className="flip-card-front"></div>
        <AnchorLink to={path}>
          <div className="flip-card-back d-flex align-items-center justify-content-center">
            <div className="">{name}</div>
          </div>
        </AnchorLink>
      </div>
    </div>
  </Col>
)

export const FlipCardRow: FunctionComponent<{
  menuItems: MenuItem[]
}> = ({ menuItems }) => (
  <Row noGutters>{mapToComponent(FlipCard, menuItems)}</Row>
)
